import { FC } from 'react';
import { AppProperties } from '@app/form_components/AppProperties';

export const SettingsPropertiesPage: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <AppProperties />
      </div>
    </div>
  );
};
